import {
  KronosTimerDialog,
  selectedProjectIDSelector,
  TimersDataGrid,
  timersForProjectSelector,
} from "../../../kronos-kit";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../hooks";
import { useSelector } from "react-redux";
import { selectedProjectID } from "../../../redux/filmsReducer";

/**
 *
 * @returns {ReactElement} ProjectTimers page
 */
export function ProjectTimers() {
  const dispatch = useDispatch();
  const projectID = useSelector(selectedProjectID);
  const timers = useAppSelector(timersForProjectSelector(projectID));

  return (
    <>
      <TimersDataGrid timers={timers} searchEnabled={false} />
      <KronosTimerDialog />
    </>
  );
}
